import { createAsyncThunk } from '@reduxjs/toolkit';
import { authApi } from '../../../api/auth/authApi.js';
import { studentsApi, teachersApi } from '@/api/index.js';

export const getProfile = createAsyncThunk('profile/getProfile', async (payload, thunkAPI) => {    
    try {        
        if (payload?.roles[0]?.name == 'Student') {
            const response = await studentsApi.getDetail(payload?.id);                        
            return response.data;
        } else {
            const response = await teachersApi.getDetail(payload?.id);
            return response.data;
        }
    } catch (e) {
        return thunkAPI.rejectWithValue(e);
    }
});
